import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class EmployeeAttendanceMonthlySummaryDto implements IEmployeeAttendanceMonthlySummaryDto {
    employee!: EmployeeSummaryDto;
    eventMonth!: Date;
    workingDay!: number;
    presentDay!: number;
    absentDay!: number;
    halfLeaveDay!: number;
    leaveDay!: number;
    missingThumbDay!: number;
    holiDay!: number;
    lateInDay!: number;
    earlyOutDay!: number;
    otDay!: number;
    shortLeaveDay!: number;
    dailyTime!: string | undefined;
    presentTime!: string | undefined;
    absentTime!: string | undefined;
    lunchTime!: string | undefined;
    earlyTime!: string | undefined;
    lateTime!: string | undefined;
    otTime!: string | undefined;
    shortLeaveTime!: string | undefined;

    constructor(data?: IEmployeeAttendanceMonthlySummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.eventMonth = _data["eventMonth"] ? new Date(_data["eventMonth"].toString()) : <any>undefined;
            this.workingDay = _data["workingDay"];
            this.presentDay = _data["presentDay"];
            this.absentDay = _data["absentDay"];
            this.halfLeaveDay = _data["halfLeaveDay"];
            this.leaveDay = _data["leaveDay"];
            this.missingThumbDay = _data["missingThumbDay"];
            this.holiDay = _data["holiDay"];
            this.lateInDay = _data["lateInDay"];
            this.earlyOutDay = _data["earlyOutDay"];
            this.otDay = _data["otDay"];
            this.shortLeaveDay = _data["shortLeaveDay"];
            this.dailyTime = _data["dailyTime"];
            this.presentTime = _data["presentTime"];
            this.absentTime = _data["absentTime"];
            this.lunchTime = _data["lunchTime"];
            this.earlyTime = _data["earlyTime"];
            this.lateTime = _data["lateTime"];
            this.otTime = _data["otTime"];
            this.shortLeaveTime = _data["shortLeaveTime"];
        }
    }

    static fromJS(data: any): EmployeeAttendanceMonthlySummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAttendanceMonthlySummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["eventMonth"] = this.eventMonth ? this.eventMonth.toISOString() : <any>undefined;
        data["workingDay"] = this.workingDay;
        data["presentDay"] = this.presentDay;
        data["absentDay"] = this.absentDay;
        data["halfLeaveDay"] = this.halfLeaveDay;
        data["leaveDay"] = this.leaveDay;
        data["missingThumbDay"] = this.missingThumbDay;
        data["holiDay"] = this.holiDay;
        data["lateInDay"] = this.lateInDay;
        data["earlyOutDay"] = this.earlyOutDay;
        data["otDay"] = this.otDay;
        data["shortLeaveDay"] = this.shortLeaveDay;
        data["dailyTime"] = this.dailyTime;
        data["presentTime"] = this.presentTime;
        data["absentTime"] = this.absentTime;
        data["lunchTime"] = this.lunchTime;
        data["earlyTime"] = this.earlyTime;
        data["lateTime"] = this.lateTime;
        data["otTime"] = this.otTime;
        data["shortLeaveTime"] = this.shortLeaveTime;
        return data; 
    }
}

export interface IEmployeeAttendanceMonthlySummaryDto {
    employee: EmployeeSummaryDto;
    eventMonth: Date;
    workingDay: number;
    presentDay: number;
    absentDay: number;
    halfLeaveDay: number;
    leaveDay: number;
    missingThumbDay: number;
    holiDay: number;
    lateInDay: number;
    earlyOutDay: number;
    otDay: number;
    shortLeaveDay: number;
    dailyTime: string | undefined;
    presentTime: string | undefined;
    absentTime: string | undefined;
    lunchTime: string | undefined;
    earlyTime: string | undefined;
    lateTime: string | undefined;
    otTime: string | undefined;
    shortLeaveTime: string | undefined;
}

